module.exports = (__webpack_require__("qkUK"))(13);


//////////////////
// WEBPACK FOOTER
// delegated ../node_modules/vuex/dist/vuex.esm.js from dll-reference vender_library
// module id = NYxO
// module chunks = 16